import React from 'react';

export default class Maintenance extends React.Component {
	render() {
		return null;
	}
}
